import React from 'react';
import './css/Advantages.css';
import {
  WHY_TOURHUNTER,
  WHY_TOURHUNTER_DESC,
  ADV1_TITLE,
  ADV1_TEXT,
  ADV2_TITLE,
  ADV2_TEXT,
  ADV3_TITLE,
  ADV3_TEXT,
  ADV4_TITLE,
  ADV4_TEXT,
} from '../../../Utils/Constants/HomePageConstants';
import Card from '../../../images/card-online-r.png';
import Support from '../../../images/support-r.png';
import Price from '../../../images/price-r.png';
import Tour from '../../../images/tour-r.png';

function Advantages() {
  return (
    <div className="containerW">
      <div className="h_advantages">
        <div className="bm_text_38 ta_center">{WHY_TOURHUNTER}</div>
        <div className="br_text_16 ta_center">{WHY_TOURHUNTER_DESC}</div>
        <div className="h_desctop_advanages">
          <div className="h_advanages_list">
            <div className="h_advanage_item">
              <div className="h_adv_item_w">
                <div className="h_adv_image_w">
                  <img src={Card} alt="card" />
                </div>
                <div className="h_adv_title ta_center mb_10">{ADV1_TITLE}</div>
                <div className="h_adv_text ta_center">{ADV1_TEXT}</div>
              </div>
            </div>

            <div className="h_advanage_item">
              <div className="h_adv_item_w">
                <div className="h_adv_image_w">
                  <img src={Support} alt="support" />
                </div>
                <div className="h_adv_title ta_center mb_10">{ADV2_TITLE}</div>
                <div className="h_adv_text ta_center">{ADV2_TEXT}</div>
              </div>
            </div>

            <div className="h_advanage_item">
              <div className="h_adv_item_w">
                <div className="h_adv_image_w">
                  <img src={Price} alt="price" />
                </div>
                <div className="h_adv_title ta_center mb_10">{ADV3_TITLE}</div>
                <div className="h_adv_text ta_center">{ADV3_TEXT}</div>
              </div>
            </div>

            <div className="h_advanage_item">
              <div className="h_adv_item_w">
                <div className="h_adv_image_w">
                  <img src={Tour} alt="tour" />
                </div>
                <div className="h_adv_title ta_center mb_10">{ADV4_TITLE}</div>
                <div className="h_adv_text ta_center">{ADV4_TEXT}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="h_tablet_advanages">
          <div className="h_tablet_advanages_content">
            <div className="h_advanages_list">
              <div className="h_advanage_item">
                <div className="h_adv_item_w">
                  <div className="h_adv_image_w">
                    <img src={Card} alt="card" />
                  </div>
                  <div className="h_adv_title ta_center mb_10">
                    {ADV1_TITLE}
                  </div>
                  <div className="h_adv_text ta_center">{ADV1_TEXT}</div>
                </div>
              </div>

              <div className="h_advanage_item">
                <div className="h_adv_item_w">
                  <div className="h_adv_image_w">
                    <img src={Support} alt="support" />
                  </div>
                  <div className="h_adv_title ta_center mb_10">
                    {ADV2_TITLE}
                  </div>
                  <div className="h_adv_text ta_center">{ADV2_TEXT}</div>
                </div>
              </div>
            </div>
            <div className="h_advanages_list">
              <div className="h_advanage_item">
                <div className="h_adv_item_w">
                  <div className="h_adv_image_w">
                    <img src={Price} alt="price" />
                  </div>
                  <div className="h_adv_title ta_center mb_10">
                    {ADV3_TITLE}
                  </div>
                  <div className="h_adv_text ta_center">{ADV3_TEXT}</div>
                </div>
              </div>

              <div className="h_advanage_item">
                <div className="h_adv_item_w">
                  <div className="h_adv_image_w">
                    <img src={Tour} alt="tour" />
                  </div>
                  <div className="h_adv_title ta_center mb_10">
                    {ADV4_TITLE}
                  </div>
                  <div className="h_adv_text ta_center">{ADV4_TEXT}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Advantages;
